import { useMutation } from "@tanstack/react-query";
import { DocumentApprovalRequest } from "apis/data-contracts";
import api from "apis";

interface RequestReviewParams {
  documentUuid: string;
  data: DocumentApprovalRequest;
}
export const useRequestReviewMutation = () => {
  return useMutation({
    mutationFn: ({ documentUuid, data }: RequestReviewParams) =>
      api.document.requestReview(documentUuid, data),
  });
};
